import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Home from "../src/pages/Home";
import HighResult from "../src/pages/HighResult.js";
import LowResult from "../src/pages/LowResult.js";

// GA 측정 ID 설정
const TRACKING_ID = "G-0MQPM4H82M";
ReactGA.initialize(TRACKING_ID);

// 페이지 뷰를 추적하는 컴포넌트
function PageTracking() {
  const location = useLocation();
  
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <PageTracking />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/result/macro" element={<HighResult />} />
        <Route path="/result/micro" element={<LowResult />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;